import * as React from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Loading from '../../shared/components/loading/Loading';
import * as moment from 'moment'
import Button from '@material-ui/core/Button';
import BreadCrumb from '../../shared/components/BreadCrumb'
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography/Typography';
import { bindActionCreators } from 'redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox'
import Grid from '@material-ui/core/Grid'
import TablePagination from '@material-ui/core/TablePagination'
import {loadSubscriptionRequestStart, loadSubscriptionRequestsSuccess } from '../../core/actions/subscriptionRequestActions'

import store from '../../../modules/core/store/index'



interface IState {
  isLoading: boolean
  checkLive: boolean
  checkSandbox: boolean
  totalElements: number
  page: number
  pageSize: number
}

class Verifications extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    const isLive = this.props.match.params.live === "Live";
    this.state = {
      isLoading: true,
      checkLive: isLive,
      checkSandbox: !isLive,
      totalElements: 25,
      page: 0,
      pageSize: 25
    }
  }

  public async componentDidMount() {
    this.loadData();
  }

  public filter() {
    return this.props.requests.filter((request: any) => {
      if (request.enviromentName === "Live" && this.state.checkLive) {
        return true
      }
      if (request.enviromentName === "Sandbox" && this.state.checkSandbox) {
        return true
      }
      return false
    })
  }

  public loadData(){
    let environmentId;
    if(this.state.checkLive && !this.state.checkSandbox){
      environmentId = 2;
    }
    if(this.state.checkSandbox && !this.state.checkLive){
      environmentId = 1;
    }
    store.dispatch(loadSubscriptionRequestStart(this.state.page+1,this.state.pageSize,environmentId));
    const { requests } = this.props;
    this.setState({totalElements: requests.length});
  }
  
  public handlePageChange = (event: any, page: number) => {
    this.setState({page}, this.loadData);
  }

  public handleChangePageSize = (event: any) => {
    this.setState({pageSize: event.target.value}, this.loadData);
  }

  public checkLive(checkBox:boolean){
    this.setState({checkLive:checkBox}, this.loadData);
  }

  public checkSandbox(checkBox:boolean){
    this.setState({checkSandbox:checkBox}, this.loadData);
  }

  public drawtable() {
    const { requests } = this.props;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>When</TableCell>
            <TableCell>Entity</TableCell>
            <TableCell>Asset</TableCell>
            <TableCell>Environment</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.length === 0 && <TableRow><TableCell colSpan={5} >No Subscription Requests</TableCell></TableRow>}
          {this.filter().map((request: any) => {
            return (
              <TableRow key={request.id}>
                <TableCell title={moment(new Date(request.time)).format('YYYY-MM-DD, h:mm a')}>{moment(new Date(request.time)).fromNow()}</TableCell>
                <TableCell component="th" scope="row">
                  {request.entityName}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request.assetName}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request.enviromentName}
                </TableCell>
                <TableCell component="th" scope="row">
                  <Button
                    component={(componentProps: any) => <NavLink to={"/verifications/" + request.id} {...componentProps} />}
                    color="secondary"
                  >
                    VERIFY
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    )
  }

  public render() {
    const { isLoading, requests } = this.props
    return (
      <div>
        <Typography variant="title" gutterBottom={true}>
          Pending Subscription Requests
        </Typography>
        <Typography color="textSecondary" gutterBottom>
          <BreadCrumb
            value='Console'
            to='/'
          />
          <BreadCrumb
            value='Assets'
            to='/verifications'
          />
          Provider
        </Typography>
        <Grid container justify="flex-start" alignItems="center" spacing={16}>
          <Grid item>
            <Typography color="textSecondary">
              show
            </Typography>
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.checkLive}
                  color="secondary"
                  onChange={(e: any) => this.checkLive( e.target.checked)}
                />
              }
              label="Live enviroments"
            />
          </Grid>
          <Grid>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.checkSandbox}
                  color="secondary"
                  onChange={(e: any) => this.checkSandbox( e.target.checked )}
                />
              }
              label="Sandbox enviroments"
            />
          </Grid>
        </Grid>
        {isLoading && requests.length === 0 ? <Loading /> : this.drawtable()}
        <TablePagination
          component="div"
          count={this.state.totalElements}
          onChangePage={this.handlePageChange}
          page={this.state.page}
          rowsPerPage={this.state.pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          onChangeRowsPerPage={this.handleChangePageSize}
        />
      </div>
    )
  }
}
function mapStateToProps(state: any) {
  return {
    requests: state.requestReducer,
    isLoading: state.isLoadingReducer
  };
}

function mapDispatchToProps(dispatch: any) {
  return bindActionCreators(
    { loadSubscriptionRequestsSuccess },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Verifications);


// WEBPACK FOOTER //
// ./src/modules/subscription/pages/PendingSubscriptions.tsx